export default "__VITE_ASSET__DTLPkd83__"